"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adornment = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _AdornmentLeft = require("../AdornmentLeft/AdornmentLeft");
var _AdornmentRight = require("../AdornmentRight/AdornmentRight");
var _excluded = ["AdornmentLeft", "AdornmentRight"];
/**
 * Used by `AdornedInput` to display ornamental text or icons.
 * Children given to this component will be vertically centered and
 * text color will be adjusted.
 *
 * @since 6.4.0
 */
var Adornment = function Adornment(_ref) {
  var Left = _ref.AdornmentLeft,
    Right = _ref.AdornmentRight,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return props.position === _constants.ADORNMENT_POSITIONS.left ? /*#__PURE__*/_react.default.createElement(Left, (0, _extends2.default)({
    "aria-hidden": "true"
  }, props)) : /*#__PURE__*/_react.default.createElement(Right, (0, _extends2.default)({
    "aria-hidden": "true"
  }, props));
};
exports.Adornment = Adornment;
Adornment.displayName = 'Adornment';
Adornment.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Since Adornments are considered ornamental, they use `aria-hidden="true"` by default.
   * If you believe your Adornment is providing additional context without repeating content
   * already present in the form field label, feel free to set `aria-hidden="false"`.
   */
  'aria-hidden': _propTypes.default.oneOf(['true', 'false']),
  /** The position of the adornment relative to the input. */
  'position': _propTypes.default.oneOf(Object.values(_constants.ADORNMENT_POSITIONS)),
  /**
   * `Adornment`s are only useful in the context of an `AdornedInput`
   * and must provide an `id` to link the label with the input.
   * **Note:** This is required, but it usually added directly by the
   * `AdornedInput`.
   */
  // Can't use `.isRequired` when dynamically added
  'htmlFor': _propTypes.default.string,
  /** The default component for `position="left"` adornments. */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  'AdornmentLeft': _propTypes.default.any,
  /** The default component for `position="right"` adornments. */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  'AdornmentRight': _propTypes.default.any
} : {};
Adornment.defaultProps = {
  'aria-hidden': 'true',
  'position': _constants.ADORNMENT_POSITIONS.left,
  AdornmentLeft: _AdornmentLeft.AdornmentLeft,
  AdornmentRight: _AdornmentRight.AdornmentRight
};